<template>
	<PayUnlockShell v-bind="shellProps" @select="$emit('select')">
		<template #left>
			<span v-if="data.tagText" class="g-block-pay-unlock__tag" :style="tagStyle">{{ data.tagText }}</span>
		</template>
		<template #info>
			<div class="g-block-pay-unlock__prices">
				<span class="g-block-pay-unlock__price" :style="priceColor">¥ {{ displayPrice }}</span>
				<span v-if="hasOriginalPrice" class="g-block-pay-unlock__original">¥ {{ displayOriginalPrice }}</span>
			</div>
			<p v-if="hasUnlockCount" class="g-block-pay-unlock__count">
				已有 <em :style="priceColor">{{ displayUnlockCount }}</em> 人解锁
			</p>
		</template>
		<template #action>
			<PayUnlockButton
				:text="data.buttonText || '解锁图片'"
				:style="buttonStyle"
				@click="onButtonClick"
			/>
		</template>
	</PayUnlockShell>
</template>

<script>
	import PayUnlockShell from '../shared/PayUnlockShell.vue';
	import PayUnlockButton from '../shared/PayUnlockButton.vue';
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayCount, formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { DEFAULT_PAY_UNLOCK_CLASSIC } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockClassic',
		components: { PayUnlockShell, PayUnlockButton },
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_CLASSIC;
			},
			shellProps() {
				return {
					data: this.data,
					editable: this.editable,
					active: this.active,
					fixedBottom: this.fixedBottom,
					h5: this.h5,
				};
			},
			displayPrice() {
				return formatPayPrice(this.data.price);
			},
			displayOriginalPrice() {
				return formatPayPrice(this.data.originalPrice);
			},
			displayUnlockCount() {
				return formatPayCount(this.data.unlockCount);
			},
			hasOriginalPrice() {
				return this.data.originalPrice !== '' && this.data.originalPrice != null;
			},
			hasUnlockCount() {
				return this.data.unlockCount !== '' && this.data.unlockCount != null;
			},
			priceColor() {
				return { color: getButtonColor(this.data, DEFAULT_PAY_UNLOCK_CLASSIC) };
			},
			tagStyle() {
				const color = getButtonColor(this.data, DEFAULT_PAY_UNLOCK_CLASSIC);
				return {
					color: color,
					background: `${color}1a`,
				};
			},
		},
	};
</script>
